"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Utility =
/*#__PURE__*/
function () {
  function Utility() {
    _classCallCheck(this, Utility);
  }

  _createClass(Utility, [{
    key: "removeClass",
    value: function removeClass(elements, myClass) {
      if (!elements) {
        return;
      }

      if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
      } else if (elements.tagName) {
        elements = [elements];
      }

      var reg = new RegExp('(^| )' + myClass + '($| )', 'g');

      for (var i = 0; i < elements.length; i++) {
        elements[i].className = elements[i].className.replace(reg, ' ');
      }
    }
  }, {
    key: "addClass",
    value: function addClass(elements, myClass) {
      if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
      } else if (elements.tagName) {
        elements = [elements];
      }

      for (var i = 0; i < elements.length; i++) {
        elements[i].classList.add(myClass);
      }
    }
  }, {
    key: "toggleClass",
    value: function toggleClass(elements, myClass) {
      if (this.hasClass(elements, myClass)) {
        this.removeClass(elements, myClass);
      } else {
        this.addClass(elements, myClass);
      }
    }
  }, {
    key: "hasClass",
    value: function hasClass(elements, myClass) {
      if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
      } else if (elements.tagName) {
        elements = [elements];
      }

      for (var i = 0; i < elements.length; i++) {
        if (elements[i].className.indexOf(myClass) > -1) {
          return true;
        } else {
          return false;
        }
      }
    }
  }, {
    key: "timer",
    value: function timer(delay) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          resolve();
        }, delay);
      });
    } //フェード

  }, {
    key: "fade",
    value: function fade(elements, duration, direction, callback) {
      var start = performance.now();
      requestAnimationFrame(function tick(timestamp) {
        var easing = (timestamp - start) / duration;
        var opacity;
        opacity = Math.min(easing, 1);

        if (direction == 'out') {
          opacity = 1 - opacity;
        }

        elements.style.opacity = opacity;

        if (easing < 1) {
          requestAnimationFrame(tick);
        } else {
          callback();
        }
      });
    } //属性の値を取得

  }, {
    key: "getAttr",
    value: function getAttr(element, attr) {
      if (element.hasAttribute(attr)) {
        return element.getAttribute(attr);
      } else {
        return '';
      }
    } //属性を削除

  }, {
    key: "removeAttr",
    value: function removeAttr(elements, attr) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var element = _step.value;

          if (document.querySelector(element) !== null) {
            if (document.querySelector(element).hasAttribute(attr)) {
              document.querySelector(element).removeAttribute(attr);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } //属性をセット

  }, {
    key: "setAttr",
    value: function setAttr(elements, attr, val) {
      var value = '';
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = elements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var element = _step2.value;

          if (document.querySelector(element) !== null) {
            if (document.querySelector(element).hasAttribute(attr)) {
              value = document.querySelector(element).getAttribute(attr);
              value += val;
            } else {
              value = val;
            }

            document.querySelector(element).setAttribute(attr, value);
            value = '';
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    } //styleの値を取得

  }, {
    key: "getStyleValue",
    value: function getStyleValue(element, style) {
      var target = document.querySelector(element);

      if (target !== null) {
        return window.getComputedStyle(target).getPropertyValue(style);
      }

      return null;
    }
  }, {
    key: "setCss",
    value: function setCss(elements, attr, val) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = elements[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var element = _step3.value;

          if (document.querySelector(element) !== null) {//document.querySelector(element).style.attr = val;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    } //

  }]);

  return Utility;
}();